export function isMsTeamsEnvironment() {
  return window.parent !== window;
}

export function isMSTeamsRoute() {
  return window.location.pathname.includes('/msteams-');
}
